import { render, staticRenderFns } from "./Propertys.vue?vue&type=template&id=281fcc01"
import script from "./Propertys.vue?vue&type=script&lang=js"
export * from "./Propertys.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports